"use client";
import '@/styles/contact/sparkles.css';

export default function GlowButton({
  label = "Book a Consultation",
  as: As = "button",
  className = "",
  ...props
}) {
  return (
    <>
      <As
        className={[
          "group relative isolate inline-flex items-center justify-center",
          "md:h-9 lg:h-12 3xl:h-14 4xl:h-16 px-3 lg:px-5 xl:px-6 3xl:px-7 4xl:px-8 py-1 lg:py-2 3xl:py-3 4xl:py-4 gap-2",
          "rounded-[7px] border border-[#FF1CF7]",
          "dark:bg-[rgba(255,28,247,0.25)] bg-[#DF27DF] dark:hover:bg-[rgba(255,28,247,0.25)] hover:bg-[#FF1CF7]",
          "shadow-[0_1px_4px_rgba(255,28,247,0.5)]",
          "outline outline-transparent",
          "hover:outline-[#FF1CF7] hover:outline-1 hover:shadow-[0_0.5px_12px_rgba(255,28,247,0.75)]",
          "cursor-pointer transition-all duration-300 ease-in-out",
          className,
        ].join(" ")}
        aria-label={label}
        {...props}
      >
        {/* inner overlay */}
        <span className="pointer-events-none absolute inset-0 rounded-[7px] z-[5]" />

        {/* sparkles */}
        <span
          aria-hidden
          className="sparkle-star absolute z-[3] left-[10.52px] -top-[7.96px] md:left-[10.52px] md:top-[-7.96px] lg:left-[10.52px] lg:top-[-7.96px]"
          style={{
            ["--sz"]: "9.48px",
            ["--r"]: "78.26deg",
            animationDelay: "160ms",
          }}
        />
        <span
          aria-hidden
          className="sparkle-star absolute z-[2] left-[119px] -top-[8px] md:left-[122px] md:top-[-8px] lg:left-[159px] lg:top-[-8px]"
          style={{
            ["--sz"]: "12.04px",
            ["--r"]: "-10.95deg",
            animationDelay: "240ms",
          }}
        />
        <span
          aria-hidden
          className="sparkle-star absolute z-[1] left-[132.59px] top-[40.7px] md:left-[135.59px] md:top-[42.7px] lg:left-[163.59px] lg:top-[56.7px] xl:left-[180.59px] xl:top-[56.7px]"
          style={{
            ["--sz"]: "8.94px",
            ["--r"]: "22.46deg",
            animationDelay: "120ms",
          }}
        />
        <span
          aria-hidden
          className="sparkle-star absolute z-0 left-[98px] md:left-[102px] lg:left-[127px] top-[50px] md:top-[53px] lg:top-[63px]"
          style={{
            ["--sz"]: "16px",
            ["--r"]: "-24.87deg",
            animationDelay: "0ms",
          }}
        />
        <span
          aria-hidden
          className="sparkle-star absolute z-[4] left-[6px] top-[39px] md:left-[6px] md:top-[42.7px] lg:left-[6px] lg:top-[53px]"
          style={{
            ["--sz"]: "20.2px",
            ["--r"]: "13.52deg",
            animationDelay: "60ms",
          }}
        />

        {/* label */}
        <span className="relative z-[6] font-[600] text-[11px] sm:text-[12px] md:text-[13px] lg:text-[14px] xl:text-[15px] 3xl:text-[18px] 4xl:text-[22px] leading-[18px] dark:text-[#FF1CF7] text-white font-albertSans">
          {label}
        </span>
      </As>
    </>
  );
}
